<script lang="ts">
	import DashListHolderNew from 'src/components/Lists/Dashboards/DashListHolderNew.svelte';
	import { ALL_ENERGY_WIDGETS_DASHBOARD, energyWidgetPreviewState } from './v2/all-energy-widgets';
	import { ALL_ENERGY_WIDGETS_DASHBOARD_ID } from './v2/energy-v2-types';
</script>

<DashListHolderNew
	id={ALL_ENERGY_WIDGETS_DASHBOARD_ID}
	dashboardOverride={ALL_ENERGY_WIDGETS_DASHBOARD}
	allowAddWidgets={false}
	allowManageWidgets={false}
	allowReorderWidgets={false}
	staticPreview={$energyWidgetPreviewState === 'sample'}
	energyPreviewState={$energyWidgetPreviewState}
/>
